import React from 'react'
import ModelFocalLengthDisplay from './ModelFocalLengthDisplay'
import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'

class FocalLengthContainer extends React.Component {
  childToRender({ props: { currentCamera: { model }, children } }) {
    if (model && complement(isEmpty)(model.focalLength)) {
      return <ModelFocalLengthDisplay focalMin={model.focalLength.min} focalMax={model.focalLength.max} />
    } else {
      return React.Children.only(children)
    }
  }

  render() {
    return this.childToRender(this)
  }
}

export default FocalLengthContainer



// WEBPACK FOOTER //
// ./src/components/FocalLengthContainer/index.js